const getStateName = (state) => {
  if (state === 'vic') {
    return 'Victoria'
  }
  if (state === 'nsw') {
    return 'New South Wales'
  }
  if (state === 'qld') {
    return 'Queensland'
  }
  if (state === 'sa') {
    return 'South Australia'
  }
  if (state === 'wa') {
    return 'Western Australia'
  }
  if (state === 'nt') {
    return 'Northern Territory'
  }
  if (state === 'act') {
    return 'ACT'
  }
  if (state === 'tas') {
    return 'Tasmania'
  }
}

export default getStateName;